import { useState } from 'react';
import { Button, Checkbox, Grid, Typography } from '@mui/material';
import './styles/custom_reports_download.scss';
import { apiPath } from '@helpers/pathHelper';

type CustomReport = {
  id: number;
  name: string;
};

export type CustomReportsDownloadProps = {
  customReports: CustomReport[];
};

const CustomReportsDownload = (props: CustomReportsDownloadProps) => {
  const [selectedReports, setSelectedReports] = useState(new Set<number>());

  return (
    <Grid
      container
      spacing={1}
      className="custom-reports-download-container"
      sx={{ textAlign: 'center', width: '100%' }}
    >
      <Grid size={12}>
        <Typography className="custom-reports-download-title">
          Attachments
        </Typography>
      </Grid>
      {props.customReports.map(customReport => (
        <Grid key={customReport.id} size={12}>
          <Grid
            container
            spacing={1}
            alignItems="center"
            className="custom-reports-download-item"
          >
            <Grid>
              <Checkbox
                color="secondary"
                onChange={e =>
                  e.target.checked
                    ? setSelectedReports(
                        new Set<number>(selectedReports.add(customReport.id))
                      )
                    : setSelectedReports(
                        new Set<number>(
                          [...selectedReports].filter(
                            id => id !== customReport.id
                          )
                        )
                      )
                }
              />
            </Grid>
            <Grid>
              <Typography>{customReport.name}</Typography>
            </Grid>
          </Grid>
        </Grid>
      ))}
      <Grid size={12} />
      <Grid size={12}>
        <Button
          onClick={() => {
            for (const reportId of selectedReports) {
              window.open(
                apiPath(`/custom_reports/${reportId}/download`),
                reportId.toString()
              );
            }
          }}
          disabled={selectedReports.size === 0}
        >
          Download
        </Button>
      </Grid>
    </Grid>
  );
};

export default CustomReportsDownload;
